import { useEffect, useMemo, useState } from "react";
import { Option } from "../../../types/types";
import useApi from "../useApi";
import { toast } from "react-toastify";
import webservice_url, { master_baseUrl } from "../../webservice/Webservice_url";

interface dataTypes {
    program_id: string;
    program_code: string;
    location_name: string;
}

// programs by project and location 
export function usePrograms(projectId: string, location: string) {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>("", {
        method: "GET",
        autoCall: false,
        handleGlobalError: false,
    });


    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.program_code,
            value: d?.program_id ?? "",
        }))
    }, [dataList])


    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi(undefined,
                   `${master_baseUrl}/projects/${projectId}/locations/${location}/programs`,);
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            setDataList([]);
            console.error(err)
        }
    }

    useEffect(() => {
        if (!projectId || !location) {
            setDataList([]);
            return;
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId, location]);

    return { dataList, options, loading };
}



// used for multi program
export function useMultiPrograms(projectId: string[], location: string[]) {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    const { callApi, loading, error } = useApi<any>(webservice_url.getProgramByMultiLocation, {
        method: "POST",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];
        return dataList.map((d) => ({
            label: d?.program_code?.replace(/_/g, " ") ?? "",
            value: d?.program_id ?? "",
        }));
    }, [dataList]);

    const fetchData = async () => {
        try {
            const res = await callApi({
                projectIds: projectId,
                locationNames: location,
            });
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            setDataList([]);
            console.error(err);
        }
    };
 
    const projectKey = (projectId ?? []).join(",");
    const locationKey = (location ?? []).join(",");

    useEffect(() => {
        if (!projectId?.length || !location?.length) {
            setDataList([]);
            return;
        }
        fetchData(); 
    }, [projectKey, locationKey]);  

    return { dataList, options, loading };
}